import { h as _objectWithoutProperties, _ as _objectSpread2, a as _slicedToArray, j as _taggedTemplateLiteral, k as _extends, l as _objectDestructuringEmpty, b as _defineProperty, B as BodyPortal, Z as ZINDEX, O as OverlayProvider } from './common.js';
export { I as IntersectionObserver, m as OverlayContext, n as OverlayPortal, P as Portal, o as onCheckHandler, p as onEnterHandler, q as onValueHandler } from './common.js';
import _styled from '@emotion/styled/base';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import React__default, { forwardRef, useRef, useState, useEffect, cloneElement, useReducer, useCallback, useMemo, createContext, useContext } from 'react';
import { R as ResizeImage, m as makeIndicatorDots, L as Loading } from './Loading.js';
export { D as DEFAULT_RESIZE_IMAGE } from './Loading.js';
import { useTheme, ClassNames, css, jsx as jsx$1, keyframes, createElement, ThemeProvider } from '@emotion/react';
import classNames from 'classnames';
import { formatComma } from '@bucketplace/lib';
import { p as pxToRem, F as FONT_STYLE, M as MEDIA_QUERY, L as LAYOUT_DESCRIPTOR, e as extractStyles, c as createStyles, P as PALETTE, R as RESET_BUTTON, s as safeAreaInset, a as RESET_INPUT, D as DARK_THEME, b as LIGHT_THEME, T as TYPOGRAPHY_DESCRIPTOR } from './foundation.js';
export { B as BREAK_POINT, i as BREAK_POINT_NAMES, v as DEPRECATED_KEYS, q as FOCUS, l as GLOBAL_IMPORT_FONT, j as GLOBAL_IMPORT_ICON, o as GLOBAL_STYLE, n as GLOBAL_STYLE_FONT, k as GLOBAL_STYLE_ICON, G as GRID_DESCRIPTORS, H as HOVER, d as MARGIN_DESCRIPTOR, O as ODS_FONT_STYLE, f as PADDING_DESCRIPTOR, h as SHADOW_STYLE, S as SIZE_DESCRIPTORS, g as TEXT_STYLE, u as hexToRgba, m as mergeStyles, r as resolvers, t as rgba } from './foundation.js';
import isPropValid from '@emotion/is-prop-valid';
import { I as InfoIcon, A as AlertFilledIcon } from './icons.js';
export { c as AddCircleFilledIcon, b as AddCircleIcon, a as AddIcon, d as AlertIcon, e as ArrowClockwiseIcon, f as ArrowDownIcon, h as ArrowLeftArrowRightIcon, g as ArrowLeftIcon, i as ArrowRightIcon, j as ArrowUpIcon, k as AttachIcon, l as BullhornFilledIcon, B as BullhornIcon, C as CalculatorIcon, n as CalendarFilledIcon, m as CalendarIcon, p as CallFilledIcon, o as CallIcon, r as CameraFilledIcon, q as CameraIcon, t as CardFilledIcon, s as CardIcon, u as CartIcon, w as CashFilledIcon, v as CashIcon, x as CheckIcon, y as ChevronDownIcon, z as ChevronLeftIcon, D as ChevronRightIcon, E as ChevronUpIcon, F as CircleCheckFilledIcon, G as CircleFilledIcon, H as CircleWonFilledIcon, K as ClockFilledIcon, J as ClockIcon, M as CommentFilledIcon, L as CommentIcon, N as ContentListIcon, P as CouponFilledIcon, O as CouponIcon, Q as CrownFilledIcon, R as CubeBadgeSparkleIcon, S as CubeOpenIcon, U as DataListFilledIcon, T as DataListIcon, W as DeleteFilledIcon, V as DeleteIcon, Y as DismissCircleIcon, X as DismissIcon, Z as DownloadIcon, _ as DropdownDownIcon, $ as DropdownRightIcon, a0 as DropdownUpIcon, a1 as ExpandIcon, a2 as ExportIcon, a4 as FaceSmilingSafetyHelmetFilledIcon, a3 as FaceSmilingSafetyHelmetIcon, a5 as FastForwardFilledIcon, a7 as FilterFilledIcon, a6 as FilterIcon, a8 as FilterNewIcon, a9 as GlobeIcon, aa as HandlerIcon, ac as HeartFilledIcon, ab as HeartIcon, ae as HomeFilledIcon, ad as HomeIcon, af as InfoFilledIcon, ag as LaunchIcon, ah as LinkIcon, aj as LocationFilledIcon, ai as LocationIcon, al as LockFilledIcon, ak as LockIcon, an as MedalFilledIcon, am as MedalIcon, ap as MenuFoldIcon, ao as MenuIcon, aq as MenuOpenIcon, ar as MoreHorizontalIcon, as as MoreVerticalIcon, au as NotificationFilledIcon, at as NotificationIcon, av as PauseIcon, aw as PhotoIcon, ax as PinIcon, az as PlayCircleFilledIcon, ay as PlayCircleIcon, aA as PlayFilledIcon, aC as PointFilledIcon, aB as PointIcon, aE as PresentFilledIcon, aD as PresentIcon, aG as ProfileFilledIcon, aF as ProfileIcon, aI as QuestionFilledIcon, aH as QuestionIcon, bq as RedoIcon, aK as ScrapFilledIcon, aJ as ScrapIcon, aL as SearchIcon, aM as SearchImageIcon, aN as SendFilledIcon, aO as SettingIcon, aP as ShareIcon, aR as ShieldFilledIcon, aQ as ShieldIcon, aS as SignOutIcon, aU as SignedFilledIcon, aT as SignedIcon, aV as SortingIcon, aW as SoundMuteFilledIcon, aX as SoundOffFilledIcon, aY as SoundOnFilledIcon, aZ as SquareAndPencilIcon, a$ as StackedImagesFilledIcon, a_ as StackedImagesIcon, b1 as StarFilledIcon, b0 as StarIcon, b2 as StatIcon, b4 as StoreFilledIcon, b3 as StoreIcon, b5 as SubtractIcon, b7 as TagFilledIcon, b6 as TagIcon, b8 as TextBoldIcon, b9 as TextItalicIcon, bb as TextRectangleOnRectangleAngledFilledIcon, ba as TextRectangleOnRectangleAngledIcon, bc as TextUnderlineIcon, be as ThumbsUpFilledIcon, bd as ThumbsUpIcon, bg as TruckFilledIcon, bf as TruckIcon, bh as TvIcon, bi as UndoIcon, bj as UploadIcon, bk as ViewListFilledIcon, bl as ViewThumbnailFilledIcon, bm as WifiIcon, bn as WonIcon, bp as WriteFilledIcon, bo as WriteIcon } from './icons.js';
import { StickyProvider } from '@bucketplace/ui';
export { c as createCachedFetch, d as decomposeHangul, u as useAutoComplete, a as useChanged, b as useForkRef, f as useIEDetector, e as useIsInApp, l as useKakaoChat, g as useMatchMedia, h as useMedia, i as useNodeSizeObserver, j as useResize, m as useResponsive, k as useWindowsOSDetector } from './hooks.js';
export { A as APP_BANNER_PATHNAME_BLACKLIST, n as APP_BANNER_SEARCH_BLACKLIST, e as calcImageSize, a as getCanonicalImageUrl, k as getCookie, g as getDeviceInfo, c as getImageSrcSet, b as getImageUrl, d as getNearestSize, h as isHiddenAppDownloadBanner, j as isHiddenMarketingBanner, i as isHigherAppVersion, m as isInApp, l as isMobile, f as isOpenAppDownloadBanner, s as setCookie } from './utils.js';
import 'react-dom';
import 'react-intersection-observer';
import 'qs';
import 'lodash/debounce';

var _excluded$h = ["size", "placeholderIcon", "src", "className", "alt", "quality"];
var placeholderIconSize = {
  18: 12,
  24: 16,
  30: 18,
  40: 24,
  80: 48
};
var Avatar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var size = _ref.size,
    PlaceholderIcon = _ref.placeholderIcon,
    src = _ref.src,
    className = _ref.className,
    alt = _ref.alt,
    quality = _ref.quality,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  return jsx(Container$6, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    className: className,
    size: size,
    children: src ? jsx(ResizeImage, {
      src: src,
      alt: alt !== null && alt !== void 0 ? alt : '아바타 사진',
      quality: quality,
      intrinsicInitialWidth: size,
      style: {
        width: '100%',
        height: '100%',
        borderRadius: '50%'
      },
      "aria-label": "avatar"
    }) : jsx(PlaceholderIcon, {
      size: placeholderIconSize[size],
      fill: function fill(theme) {
        return theme.base.neutral500;
      },
      "aria-label": "avatar-placeholder"
    })
  }));
});
var Container$6 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "egjvr3j0"
} : {
  target: "egjvr3j0",
  label: "Container"
})("width:", function (_ref2) {
  var size = _ref2.size;
  return size;
}, "px;height:", function (_ref3) {
  var size = _ref3.size;
  return size;
}, "px;border-radius:50%;background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.base.neutral300;
}, ";display:flex;align-items:center;justify-content:center;");

var _templateObject$1;
/**
 * children에 hover interaction을 적용합니다.
 * children component에 className props가 필요합니다.
 * 타겟이 되는 컴포넌트의 position을 relative로 설정하고, hover interaction을 적용합니다.
 * 만약 relative가 아닌 다른 position을 사용하고 싶다면, HoverInteraction을 한번더 Wrapper로 감싸서 적용해주세요.
 * @param children
 * @param disabled
 * @constructor
 */
var HoverInteraction = function HoverInteraction(_ref) {
  var _children = _ref.children,
    disabled = _ref.disabled;
  var theme = useTheme();
  var childRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    borderWidth = _useState2[0],
    setBorderWidth = _useState2[1];
  useEffect(function () {
    if (childRef.current && typeof window !== 'undefined') {
      var computedStyle = window.getComputedStyle(childRef.current);
      var border = computedStyle.getPropertyValue('border-width');
      setBorderWidth(parseFloat(border));
    }
  }, []);
  return jsx(ClassNames, {
    children: function children(_ref2) {
      var css = _ref2.css;
      return /*#__PURE__*/cloneElement(_children, {
        ref: childRef,
        className: classNames(!disabled && css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n              position: relative;\n              @media (hover: hover) or (pointer: fine) {\n                cursor: pointer;\n                &::after {\n                  content: '';\n                  position: absolute;\n                  left: -", ";\n                  top: -", ";\n                  right: -", ";\n                  bottom: -", ";\n                  transition: background-color 0.1s ease-in-out;\n                  border-radius: inherit;\n                  background-color: initial;\n                }\n                &:hover::after {\n                  // TODO \uCEEC\uB7EC ODS \uC801\uC6A9\n                  background-color: ", ";\n                }\n              }\n            "])), pxToRem(borderWidth), pxToRem(borderWidth), pxToRem(borderWidth), pxToRem(borderWidth), theme.dim.thin), _children.props.className)
      });
    }
  });
};

var _excluded$g = ["text", "number", "variant", "leftIcon", "rightIcon", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var getColorTokenProps = function getColorTokenProps(variant, theme) {
  var colorTokens = {
    primary_thin: {
      backgroundColor: theme.primary.lighten,
      textColor: theme.primary.darken,
      borderColor: theme.primary.darken,
      numberColor: theme.primary.darken
    },
    white: {
      backgroundColor: theme.base.neutral0,
      textColor: theme.base.neutral700,
      borderColor: theme.border,
      numberColor: theme.primary.darken
    },
    base5: {
      backgroundColor: theme.base.neutral100,
      textColor: theme.base.neutral700,
      borderColor: theme.base.neutral100,
      numberColor: theme.primary.darken
    },
    base1: {
      backgroundColor: theme.base.neutral600,
      textColor: theme.base.neutral0,
      borderColor: theme.base.neutral600,
      numberColor: theme.primary.darken
    }
  };
  return colorTokens[variant];
};
var Chip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var text = _ref.text,
    number = _ref.number,
    variant = _ref.variant,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    className = _ref.className,
    restProps = _objectWithoutProperties(_ref, _excluded$g);
  var theme = useTheme();
  return jsx(HoverInteraction, {
    children: jsxs(Container$5, _objectSpread2(_objectSpread2(_objectSpread2({
      ref: ref
    }, restProps), getColorTokenProps(variant, theme)), {}, {
      className: classNames(className, {
        clickable: !!restProps.onClick
      }),
      children: [leftIcon && /*#__PURE__*/cloneElement(leftIcon, {
        size: 12,
        className: 'left-icon'
      }), text, typeof number === 'number' && jsx("span", {
        className: "chip-number",
        children: formatComma(number)
      }), rightIcon && /*#__PURE__*/cloneElement(rightIcon, {
        size: 12,
        className: 'right-icon'
      })]
    }))
  });
});
var Container$5 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1grob030"
} : {
  target: "e1grob030",
  label: "Container"
})(FONT_STYLE.body14L18, ";position:relative;display:inline-flex;align-items:center;background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";color:", function (_ref3) {
  var textColor = _ref3.textColor;
  return textColor;
}, ";border-radius:50px;box-sizing:border-box;height:38px;padding:10px 14px;", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "7b80yc",
  styles: "border-radius:100px;height:32px;padding:7px 12px"
} : {
  name: "1i1jq1h-Container",
  styles: "border-radius:100px;height:32px;padding:7px 12px;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), " &::before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;border:1px solid ", function (_ref4) {
  var borderColor = _ref4.borderColor;
  return borderColor;
}, ";border-radius:inherit;}&.clickable{cursor:pointer;}.chip-number{color:", function (_ref5) {
  var numberColor = _ref5.numberColor;
  return numberColor;
}, ";margin-left:2px;}.left-icon{margin-right:4px;}.right-icon{margin-left:4px;}");

var BadgeBaseContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e6n7lej1"
} : {
  target: "e6n7lej1",
  label: "BadgeBaseContainer"
})("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.accent.basic;
}, ";color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.base.neutral0;
}, ";font-weight:700;letter-spacing:-0.3px;display:inline-flex;justify-content:center;align-items:center;");
var CircleBadgeContainer = /*#__PURE__*/_styled(BadgeBaseContainer, process.env.NODE_ENV === "production" ? {
  target: "e6n7lej0"
} : {
  target: "e6n7lej0",
  label: "CircleBadgeContainer"
})("border-radius:47px;flex-direction:column;", function (_ref3) {
  var size = _ref3.size;
  switch (size) {
    case 16:
      {
        return /*#__PURE__*/css(FONT_STYLE.detail10L14, " height:16px;padding:0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:CircleBadgeContainer;"));
      }
    case 20:
      {
        return /*#__PURE__*/css(FONT_STYLE.detail12L16, ";height:20px;padding:0px 7px;" + (process.env.NODE_ENV === "production" ? "" : ";label:CircleBadgeContainer;"));
      }
  }
}, ";");

var _excluded$f = ["size", "value"];
var MAX_VALUE = 99;
var CircleBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var size = props.size,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded$f);
  return jsx(CircleBadgeContainer, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    size: size,
    children: value > MAX_VALUE ? "".concat(MAX_VALUE, "+") : value
  }));
});

var _excluded$e = ["size", "variant", "children", "leftIcon", "rightIcon", "className"];
var SquareBadge = function SquareBadge(props) {
  var size = props.size,
    variant = props.variant,
    children = props.children,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded$e);
  var iconSize = size === 24 ? 16 : 12;
  return jsxs(SquareBadgeContainer, _objectSpread2(_objectSpread2({}, rest), {}, {
    size: size,
    className: classNames(className, variant),
    children: [leftIcon && /*#__PURE__*/cloneElement(leftIcon, {
      size: iconSize,
      className: 'left-icon'
    }), children, rightIcon && /*#__PURE__*/cloneElement(rightIcon, {
      size: iconSize,
      className: 'right-icon'
    })]
  }));
};
var FontStyleBySize = {
  16: /*#__PURE__*/css(FONT_STYLE.detail10L14, " height:16px;padding:0px 4px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")),
  20: /*#__PURE__*/css(FONT_STYLE.detail12L16, ";height:20px;padding:0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")),
  24: /*#__PURE__*/css(FONT_STYLE.detail12L16, ";height:24px;padding:0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;"))
};
var SquareBadgeContainer = /*#__PURE__*/_styled(BadgeBaseContainer, process.env.NODE_ENV === "production" ? {
  target: "e15u479s0"
} : {
  target: "e15u479s0",
  label: "SquareBadgeContainer"
})("border-radius:4px;flex-direction:row;gap:4px;flex-shrink:0;&.primary{background:", function (_ref) {
  var theme = _ref.theme;
  return theme.primary.basic;
}, ";}&.accent{background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.accent.basic;
}, ";}&.dim_dark{background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.interactive.dim.thick;
}, ";}&.neutral300{background:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.base.neutral300;
}, ";color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.base.neutral500;
}, ";}&.neutral500{background:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.base.neutral500;
}, ";}", function (_ref7) {
  var size = _ref7.size;
  return FontStyleBySize[size];
}, ";");

var _excluded$d = ["size", "value"];
var PillBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var size = props.size,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded$d);
  return jsx(CircleBadgeContainer, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    size: size,
    children: value
  }));
});

var DotBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(props), props));
  return jsx(Container$4, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    "data-testid": "dot-badge"
  }));
});
var Container$4 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e78z9x80"
} : {
  target: "e78z9x80",
  label: "Container"
})("display:inline-block;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.accent.basic;
}, ";width:4px;height:4px;border-radius:50%;");

var _excluded$c = ["children", "as", "asProps"],
  _excluded2$4 = ["styles"];
var BOX_OWN_DESCRIPTORS = {
  display: {
    property: 'display',
    type: 'identity'
  }
};
var BOX_DESCRIPTORS = _objectSpread2(_objectSpread2({}, LAYOUT_DESCRIPTOR), BOX_OWN_DESCRIPTORS);
function InnerBox(props, ref) {
  var children = props.children,
    _props$as = props.as,
    as = _props$as === void 0 ? 'div' : _props$as,
    asProps = props.asProps,
    restProps = _objectWithoutProperties(props, _excluded$c);
  var theme = useTheme();
  var _extractStyles = extractStyles(restProps, BOX_DESCRIPTORS),
    styles = _extractStyles.styles,
    rest = _objectWithoutProperties(_extractStyles, _excluded2$4);
  var css = createStyles({
    theme: theme,
    props: styles,
    descriptors: BOX_DESCRIPTORS
  });
  return jsx$1(as, _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: css
  }, asProps), children);
}
InnerBox.displayName = 'Box';
var Box = /*#__PURE__*/forwardRef(InnerBox);

var _excluded$b = ["children", "as", "display", "direction", "asProps"],
  _excluded2$3 = ["styles"];
var FLEX_OWN_DESCRIPTORS = {
  display: {
    property: 'display',
    type: 'identity'
  },
  direction: {
    property: 'flexDirection',
    type: 'identity'
  },
  basis: {
    property: 'flexBasis',
    type: 'size'
  },
  grow: {
    property: 'flexGrow',
    type: 'identity'
  },
  shrink: {
    property: 'flexShrink',
    type: 'identity'
  },
  align: {
    property: 'alignItems',
    type: 'identity'
  },
  justify: {
    property: 'justifyContent',
    type: 'identity'
  },
  wrap: {
    property: 'flexWrap',
    type: 'identity'
  },
  gap: {
    property: 'gap',
    type: 'spacing'
  },
  columnGap: {
    property: 'columnGap',
    type: 'size'
  },
  rowGap: {
    property: 'rowGap',
    type: 'size'
  }
};
var FLEX_DESCRIPTORS = _objectSpread2(_objectSpread2({}, LAYOUT_DESCRIPTOR), FLEX_OWN_DESCRIPTORS);
function InnerFlex(props, ref) {
  var children = props.children,
    _props$as = props.as,
    as = _props$as === void 0 ? 'div' : _props$as,
    _props$display = props.display,
    display = _props$display === void 0 ? 'flex' : _props$display,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'column' : _props$direction,
    asProps = props.asProps,
    restProps = _objectWithoutProperties(props, _excluded$b);
  var theme = useTheme();
  var _extractStyles = extractStyles(_objectSpread2(_objectSpread2({}, restProps), {}, {
      display: display,
      direction: direction
    }), FLEX_DESCRIPTORS),
    styles = _extractStyles.styles,
    rest = _objectWithoutProperties(_extractStyles, _excluded2$3);
  var css = createStyles({
    theme: theme,
    props: styles,
    descriptors: FLEX_DESCRIPTORS
  });
  return jsx$1(as, _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: css
  }, asProps), children);
}
InnerFlex.displayName = 'Flex';
/**
 * @example
 * <Flex
 *  as="section"
 *  gap={{ mobile: 16, tablet: 24, desktop: 32 }}
 * >
 *   <Flex shrink={0}><Text>아이템</Text></Flex>
 *   <Flex grow={1}><Text>아이템</Text></Flex>
 *   <Flex flex="1 1 auto"><Text>아이템</Text></Flex>
 * </Flex>
 */
var Flex = /*#__PURE__*/forwardRef(InnerFlex);

var _excluded$a = ["children", "as", "display", "asProps"],
  _excluded2$2 = ["styles"];
var GRID_OWN_DESCRIPTORS = {
  display: {
    property: 'display',
    type: 'identity'
  },
  areas: {
    property: 'gridTemplateAreas',
    type: 'identity'
  },
  columns: {
    property: 'gridTemplateColumns',
    type: 'grid'
  },
  rows: {
    property: 'gridTemplateRows',
    type: 'grid'
  },
  align: {
    property: 'alignItems',
    type: 'identity'
  },
  justify: {
    property: 'justifyContent',
    type: 'identity'
  },
  gap: {
    property: 'gap',
    type: 'spacing'
  },
  columnGap: {
    property: 'columnGap',
    type: 'size'
  },
  rowGap: {
    property: 'rowGap',
    type: 'size'
  },
  flow: {
    property: 'gridAutoFlow',
    type: 'identity'
  }
};
var GRID_DESCRIPTORS = _objectSpread2(_objectSpread2({}, LAYOUT_DESCRIPTOR), GRID_OWN_DESCRIPTORS);
function InnerGrid(props, ref) {
  var children = props.children,
    _props$as = props.as,
    as = _props$as === void 0 ? 'div' : _props$as,
    _props$display = props.display,
    display = _props$display === void 0 ? 'grid' : _props$display,
    asProps = props.asProps,
    restProps = _objectWithoutProperties(props, _excluded$a);
  var theme = useTheme();
  var _extractStyles = extractStyles(_objectSpread2(_objectSpread2({}, restProps), {}, {
      display: display
    }), GRID_DESCRIPTORS),
    styles = _extractStyles.styles,
    rest = _objectWithoutProperties(_extractStyles, _excluded2$2);
  var css = createStyles({
    theme: theme,
    props: styles,
    descriptors: GRID_DESCRIPTORS
  });
  return jsx$1(as, _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: css
  }, asProps), children);
}
InnerGrid.displayName = 'Grid';
/**
 * 그리드 컴포넌트
 * @example
 * <Grid
 *  gap={{ mobile: 16, tablet: 24, desktop: 32 }}
 * >
 *   <Box>아이템</Box>
 *   <Box>아이템</Box>
 *   <Box>아이템</Box>
 * </Grid>
 */
var Grid = /*#__PURE__*/forwardRef(InnerGrid);

/**
 * Divider
 * @see {@link https://www.figma.com/design/aTdWM1sgdScr68GZdQ2sWO/ODS-(Ohouse-Design-System)-Master?node-id=21462-14943&t=DjaawziSis6vCaS1-0}
 */
var Divider = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(DividerContainer, _objectSpread2({
    ref: ref
  }, props));
});
var DividerContainer = /*#__PURE__*/_styled("hr", process.env.NODE_ENV === "production" ? {
  target: "e15zb1dk0"
} : {
  target: "e15zb1dk0",
  label: "DividerContainer"
})("margin:0;padding:0;height:", function (_ref) {
  var height = _ref.height;
  return height;
}, "px;border:none;background-color:", function (_ref2) {
  var theme = _ref2.theme,
    height = _ref2.height;
  return height === 1 ? theme.base.neutral300 : theme.base.neutral100;
}, ";");

function dotSize(index, maxPage, activeIndex) {
  if (maxPage <= 4) {
    return index === activeIndex ? 8 : 6;
  }
  // activeIndex의 왼쪽.
  if (index <= activeIndex) {
    var delta = activeIndex - index;
    if (activeIndex === maxPage - 1) {
      if (delta <= 2) {
        return 8;
      } else if (delta === 3) {
        return 6;
      } else if (delta === 4) {
        return 4;
      }
      return 0;
    } else {
      if (delta <= 2) {
        return 8;
      } else if (delta === 3) {
        return 6;
      }
      return 0;
    }
  }
  // activeIndex의 오른쪽.
  if (activeIndex <= 2) {
    if (index <= 2) {
      return 8;
    } else if (index === 3) {
      return 6;
    } else if (index === 4) {
      return 4;
    }
    return 0;
  } else {
    return index - activeIndex === 1 ? 6 : 0;
  }
}
function IndicatorDots(props) {
  var theme = useTheme();
  return makeIndicatorDots({
    dotSize: dotSize,
    dotBackgroundColor: theme.dim.onDark.thick,
    activeDotBackgroundColor: PALETTE.white,
    boxShadow: "".concat(pxToRem(0), " ").concat(pxToRem(2), " ").concat(pxToRem(5), " ").concat(theme.shadow.basic)
  })(props);
}

/**
 * 스낵바 메시지 위치 옵션
 * - basic : 바텀 하단에 스낵바 메시지 노출
 * - fab : FAB 가 보이도록 메시지 노출
 */
var SNACKBAR_PLACEMENT = {
  basic: 'basic',
  fab: 'fab'
};

function snackBarReducer(state, action) {
  switch (action.type) {
    case 'open':
      {
        var newItem = {
          id: state.id,
          state: 'open',
          options: action.options
        };
        state.items.forEach(function (item) {
          var _a, _b;
          (_b = (_a = item.options).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
        var items = [newItem];
        return _objectSpread2(_objectSpread2({}, state), {}, {
          id: state.id + 1,
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'close':
      {
        var _items = state.items.map(function (v) {
          if (v.id === action.id) {
            return _objectSpread2(_objectSpread2({}, v), {}, {
              state: 'closing'
            });
          }
          return v;
        });
        return _objectSpread2(_objectSpread2({}, state), {}, {
          items: _items,
          placement: getPlacement(_items)
        });
      }
    case 'closeAll':
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          items: state.items.map(function (v) {
            return _objectSpread2(_objectSpread2({}, v), {}, {
              state: 'closing'
            });
          })
        });
      }
    case 'closed':
      {
        var entry = state.items.find(function (v) {
          return v.id === action.id;
        });
        if (entry != null && entry.options.onClose != null) {
          entry.options.onClose();
        }
        var _items2 = state.items.filter(function (v) {
          return v.id !== action.id;
        });
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isEngaged: state.items.length > 1 ? state.isEngaged : false,
          items: _items2,
          placement: getPlacement(_items2)
        });
      }
    case 'engage':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isEngaged: true
      });
    case 'disengage':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isEngaged: false
      });
    case 'shift':
      {
        var closeItem = state.items.find(function (v) {
          return v.state === 'open';
        });
        if (closeItem == null) return state;
        return snackBarReducer(state, {
          type: 'close',
          id: closeItem.id
        });
      }
    default:
      return state;
  }
}
/**
 * 스낵바 상태를 관리하는 훅입니다.
 * 스낵바는 queue 형태로 관리하고 있으나, queue내에 한번에 존재할 수 있는 스낵바는 1개로 제한됩니다.
 * 기존 스낵바가 shift 된기 전에 새로운 스낵바가 들어오면 기존 스낵바는 곧바로 shift되어 별도의 closing 상태(fadeout 애니메이션)를 거치지 않고 제거됩니다.
 * 또한, 유저가 스낵바와 인터렉션 중인 상태일 때에는 (engaged) 스낵바가 closing 상태로 변경되지 않도록 isEngaged 상태를 관리합니다.
 * @returns SnackbarStateResult
 */
function useSnackbarState() {
  var _useReducer = useReducer(snackBarReducer, {
      id: 0,
      isEngaged: false,
      items: [],
      placement: SNACKBAR_PLACEMENT.basic
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var handleEngage = useCallback(function () {
    dispatch({
      type: 'engage'
    });
  }, [dispatch]);
  var handleDisengage = useCallback(function () {
    dispatch({
      type: 'disengage'
    });
  }, [dispatch]);
  var handleOpen = useCallback(function (options) {
    dispatch({
      type: 'open',
      options: options
    });
  }, [dispatch]);
  var handleClose = useCallback(function (id) {
    dispatch({
      type: 'close',
      id: id
    });
  }, [dispatch]);
  var handleClosed = useCallback(function (id) {
    dispatch({
      type: 'closed',
      id: id
    });
  }, [dispatch]);
  var handleCloseAll = useCallback(function () {
    dispatch({
      type: 'closeAll'
    });
  }, [dispatch]);
  useEffect(function () {
    if (state.isEngaged || state.items.length === 0) return;
    var closeItem = state.items.find(function (v) {
      return v.state === 'open';
    });
    if (closeItem != null) {
      // If it's not engaged, try to remove items every few seconds
      var duration = closeItem.options.duration || 3000;
      var timer = setTimeout(function () {
        return dispatch({
          type: 'shift'
        });
      }, duration);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [dispatch, state]);
  var result = useMemo(function () {
    return {
      state: state,
      closeAll: handleCloseAll,
      close: handleClose,
      closed: handleClosed,
      open: handleOpen,
      engage: handleEngage,
      disengage: handleDisengage
    };
  }, [state, handleCloseAll, handleClose, handleClosed, handleOpen, handleEngage, handleDisengage]);
  return result;
}
/**
 * 오픈된 스낵바 아이템을 순회하여 스낵바를 노출할 위치를 리턴합니다.
 * fab가 하나라도 존재하면 fab로 리턴하고, 그렇지 않으면 basic을 리턴합니다.
 */
function getPlacement(items) {
  return items.some(function (item) {
    return item.options.placement === SNACKBAR_PLACEMENT.fab;
  }) ? SNACKBAR_PLACEMENT.fab : SNACKBAR_PLACEMENT.basic;
}

var _excluded$9 = ["children"];
// TODO Button 을 Anchor로도 사용 가능한 형태로 개선 필요.
var BaseButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded$9);
  return jsx(HoverInteraction, {
    disabled: restProps.disabled,
    children: jsx(ResetButton, _objectSpread2(_objectSpread2({}, restProps), {}, {
      ref: ref,
      children: children
    }))
  });
});
var ResetButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e117vx0e0"
} : {
  target: "e117vx0e0",
  label: "ResetButton"
})(RESET_BUTTON, ";cursor:pointer;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;");

var _excluded$8 = ["children", "size", "variant", "rightIcon", "leftIcon", "className"];
var iconSize = {
  14: 12,
  16: 16
};
var TextButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    size = props.size,
    variant = props.variant,
    RightIcon = props.rightIcon,
    LeftIcon = props.leftIcon,
    className = props.className,
    restProps = _objectWithoutProperties(props, _excluded$8);
  return jsxs(TextButtonContainer, _objectSpread2(_objectSpread2({
    className: classNames([variant, "size-".concat(size), className])
  }, restProps), {}, {
    ref: ref,
    children: [LeftIcon && jsx(LeftIcon, {
      "data-testid": "left-icon",
      className: "left-icon",
      size: iconSize[size]
    }), children, RightIcon && jsx(RightIcon, {
      "data-testid": "right-icon",
      className: "right-icon",
      size: iconSize[size]
    })]
  }));
});
var TextButtonContainer = /*#__PURE__*/_styled(BaseButton, process.env.NODE_ENV === "production" ? {
  target: "e1wbybap0"
} : {
  target: "e1wbybap0",
  label: "TextButtonContainer"
})("padding:", pxToRem(4), " ", pxToRem(8), ";border-radius:4px;&.primary{color:", function (_ref) {
  var theme = _ref.theme;
  return theme.primary.basic;
}, ";}&.neutral-500{color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.base.neutral500;
}, ";}&.neutral-600{color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.base.neutral600;
}, ";}&:disabled{color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.base.neutral400;
}, ";}&.size-14{", FONT_STYLE.body14L18, ";}&.size-16{", FONT_STYLE.body16L20, ";font-weight:500;}.left-icon{margin-right:", pxToRem(4), ";}.right-icon{margin-left:", pxToRem(4), ";}");

var _templateObject, _templateObject2;
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var fadeIn = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));
function cssAnimation(isClosing) {
  if (!isClosing) return /*#__PURE__*/css("animation:", fadeIn, " 0.3s 0.1s cubic-bezier(0.33, 1, 0.68, 1) both;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssAnimation;"));
  return /*#__PURE__*/css("animation:", fadeOut, " 0.2s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssAnimation;"));
}
function SnackbarItem(_ref) {
  var className = _ref.className,
    PrefixIcon = _ref.prefixIcon,
    content = _ref.content,
    buttons = _ref.buttons,
    onClick = _ref.onClick,
    onCloseAnimationEnd = _ref.onCloseAnimationEnd,
    isClosing = _ref.isClosing,
    suffixButton = _ref.suffixButton;
  return jsxs(SnackbarWrapper, {
    "data-testid": "snackbar-item",
    className: className,
    css: [cssAnimation(isClosing)],
    onClick: onClick,
    onAnimationEnd: isClosing ? onCloseAnimationEnd : undefined,
    children: [!!PrefixIcon && jsx(PrefixIcon, {
      "data-testid": "snackbar-item-icon",
      className: "prefix-icon",
      size: 18
    }), jsx(Content, {
      children: content
    }), suffixButton && jsx(SnackbarButton, {
      size: 14,
      variant: "primary",
      type: "button",
      onClick: suffixButton.onClick,
      children: suffixButton.title
    }), buttons && (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && jsx(ButtonWrapper$2, {
      children: buttons.map(function (buttonProps, i) {
        return /** FIXME TextButton 구현 후 적용 */jsx(SnackbarButton, _objectSpread2({
          size: 14,
          variant: "primary",
          type: "button"
        }, buttonProps), i);
      })
    })]
  });
}
var SnackbarWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efmkyib3"
} : {
  target: "efmkyib3",
  label: "SnackbarWrapper"
})("box-sizing:border-box;display:flex;padding:", pxToRem(14), " ", pxToRem(16), ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.layer.dark;
}, ";border-radius:", pxToRem(4), ";", FONT_STYLE.body14L18, ";color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.base.neutral0;
}, ";margin-top:", pxToRem(15), ";width:", pxToRem(470), ";", MEDIA_QUERY.max('tablet', /*#__PURE__*/css("width:", pxToRem(350), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SnackbarWrapper;"))), " ", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1or42k3-SnackbarWrapper",
  styles: "width:100%;label:SnackbarWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
}), " .prefix-icon{margin-right:", pxToRem(6), ";}");
var Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efmkyib2"
} : {
  target: "efmkyib2",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "j05eyw",
  styles: "flex:1 1;white-space:pre-line;word-break:keep-all;overflow-wrap:break-word"
} : {
  name: "j05eyw",
  styles: "flex:1 1;white-space:pre-line;word-break:keep-all;overflow-wrap:break-word",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var ButtonWrapper$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efmkyib1"
} : {
  target: "efmkyib1",
  label: "ButtonWrapper"
})("margin-left:", pxToRem(4), ";");
var SnackbarButton = /*#__PURE__*/_styled(TextButton, process.env.NODE_ENV === "production" ? {
  target: "efmkyib0"
} : {
  target: "efmkyib0",
  label: "SnackbarButton"
})("padding:0;&:not(:first-of-type){margin-left:", pxToRem(8), ";}");

var _excluded$7 = ["icon", "type", "multiline"];
var convertBdsOptionAsOds = function convertBdsOptionAsOds(props) {
  var icon = props.icon,
    type = props.type,
    multiline = props.multiline,
    rest = _objectWithoutProperties(props, _excluded$7);
  var newProps = rest;
  if (icon) {
    console.warn('Snackbar: icon is deprecated. Use prefixIcon instead.');
    newProps = _objectSpread2(_objectSpread2({}, newProps), {}, {
      prefixIcon: InfoIcon
    });
  }
  if (type) {
    console.warn('Snackbar: type is deprecated. Only normal type design is allowed.');
  }
  // deprecated 되어야 할 대상이지만, 하위호환성을 위해 실제 구현 단에서는 활용하도록 남겨둡니다.
  if (rest.buttons) {
    console.warn('Snackbar: buttons is deprecated. Use button props instead.');
  }
  if (multiline) {
    console.warn('Snackbar: multiline is deprecated. Do not use multiline.');
  }
  return newProps;
};

/** 스낵바 위치 */
var BOTTOM_SIZE = _defineProperty(_defineProperty({}, SNACKBAR_PLACEMENT.basic, {
  mobile: 8,
  pc: 40
}), SNACKBAR_PLACEMENT.fab, {
  mobile: 70,
  pc: 40
});
function SnackbarList(props) {
  var _props$state = props.state,
    items = _props$state.items,
    placement = _props$state.placement,
    close = props.close,
    closed = props.closed,
    engage = props.engage,
    disengage = props.disengage;
  // TODO 사용되는 서비스들에서 마이그레이션 완료 후 제거
  var odsItems = useMemo(function () {
    return items.map(function (item) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        options: convertBdsOptionAsOds(item.options)
      });
    });
  }, [items]);
  return jsx(BodyPortal, {
    children: jsx(Wrapper, _objectSpread2(_objectSpread2({
      id: "snackbar-list-wrapper",
      "data-testid": "snackbar-list-wrapper"
    }, props), {}, {
      onMouseEnter: engage,
      onMouseLeave: disengage,
      placement: placement,
      children: odsItems.map(function (_ref, index) {
        var id = _ref.id,
          state = _ref.state,
          options = _ref.options;
        return createElement(SnackbarItem, _objectSpread2(_objectSpread2({}, options), {}, {
          key: id,
          isClosing: state === 'closing',
          onClick: function onClick() {
            var _a;
            (_a = options.onClick) === null || _a === void 0 ? void 0 : _a.call(options);
            close(id);
          },
          onCloseAnimationEnd: function onCloseAnimationEnd() {
            return closed(id);
          }
        }));
      })
    }))
  });
}
var Wrapper = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && !['open'].includes(prop);
  },
  target: "e1z07hv00"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && !['open'].includes(prop);
  },
  target: "e1z07hv00",
  label: "Wrapper"
})(function (_ref2) {
  var placement = _ref2.placement;
  return /*#__PURE__*/css("position:fixed;display:flex;flex-direction:column;align-items:center;justify-content:center;bottom:", pxToRem(BOTTOM_SIZE[placement].pc), ";padding-inline:8px;z-index:", ZINDEX.snackbar, ";left:0;right:0;", MEDIA_QUERY.max('tablet', /*#__PURE__*/css("bottom:", pxToRem(BOTTOM_SIZE[placement].mobile), ";", safeAreaInset('bottom', 'padding-bottom'), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;"));
});

var SnackbarContext = /*#__PURE__*/createContext(null);
function SnackbarProvider(_ref) {
  var children = _ref.children;
  var state = useSnackbarState();
  return jsxs(SnackbarContext.Provider, {
    value: state,
    children: [children, jsx(SnackbarList, _objectSpread2({}, state))]
  });
}
function useSnackbar() {
  var result = useContext(SnackbarContext);
  if (result == null) {
    throw new Error('SnackbarContext is not mounted');
  }
  return result;
}

var _excluded$6 = ["icon", "value", "valueAlignment", "className", "isActive", "activeIcon", "hasBorder"];
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var IconElement = _ref.icon,
    value = _ref.value,
    _ref$valueAlignment = _ref.valueAlignment,
    valueAlignment = _ref$valueAlignment === void 0 ? 'horizontal' : _ref$valueAlignment,
    className = _ref.className,
    isActive = _ref.isActive,
    ActiveIcon = _ref.activeIcon,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? false : _ref$hasBorder,
    rest = _objectWithoutProperties(_ref, _excluded$6);
  return jsxs(Container$3, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    className: classNames(className, {
      horizontal: valueAlignment === 'horizontal',
      vertical: valueAlignment === 'vertical'
    }),
    type: "button",
    children: [jsx(IconWrapper, {
      className: classNames({
        border: hasBorder
      }),
      "data-testid": "icon-wrapper",
      children: ActiveIcon && isActive ? jsx(ActiveIcon, {
        size: 24,
        "data-testid": "active-icon",
        fill: function fill(theme) {
          return theme.primary.basic;
        }
      }) : jsx(IconElement, {
        size: 24,
        "data-testid": "inactive-icon",
        fill: function fill(theme) {
          return theme.base.neutral700;
        }
      })
    }), value && jsx(ValueText, {
      children: formatComma(value)
    })]
  }));
});
var Container$3 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e2itrfe2"
} : {
  target: "e2itrfe2",
  label: "Container"
})("background:none;border:none;color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.base.neutral700;
}, ";font-family:inherit;padding:0;margin:0;display:inline-flex;justify-content:center;align-items:center;gap:4px;&.vertical{flex-direction:column;}&.horizontal{flex-direction:row;}");
var IconWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2itrfe1"
} : {
  target: "e2itrfe1",
  label: "IconWrapper"
})("&.border{padding:10px;border:1px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.border;
}, ";border-radius:50%;}>svg{vertical-align:middle;}");
var ValueText = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e2itrfe0"
} : {
  target: "e2itrfe0",
  label: "ValueText"
})(FONT_STYLE.detail12L16, ";");

var boxButtonColorLookup = function boxButtonColorLookup(theme) {
  return {
    filled: {
      'primary': {
        backgroundColor: theme.primary.basic,
        disabledBorderColor: theme.disabled.filled1,
        borderColor: theme.primary.basic,
        textColor: theme.base.neutral0,
        disabledBackgroundColor: theme.disabled.filled1,
        disabledTextColor: theme.base.neutral400
      },
      'neutral-600': {
        backgroundColor: '',
        disabledBorderColor: '',
        borderColor: '',
        textColor: '',
        disabledBackgroundColor: '',
        disabledTextColor: ''
      }
    },
    outlined: {
      'primary': {
        borderColor: theme.primary.basic,
        textColor: theme.primary.basic,
        disabledBorderColor: theme.border,
        disabledTextColor: theme.base.neutral400,
        backgroundColor: 'inherit',
        disabledBackgroundColor: 'inherit'
      },
      'neutral-600': {
        borderColor: theme.border,
        textColor: theme.base.neutral600,
        disabledBorderColor: theme.border,
        disabledTextColor: theme.base.neutral400,
        backgroundColor: 'inherit',
        disabledBackgroundColor: 'inherit'
      }
    }
  };
};
var boxButtonSizeLookup = {
  28: {
    paddingInline: 8,
    paddingBlock: 4,
    fontWeight: 500,
    fontSize: FONT_STYLE.body14L20
  },
  32: {
    paddingInline: 8,
    paddingBlock: 6,
    fontWeight: 600,
    fontSize: FONT_STYLE.body14L20
  },
  40: {
    paddingInline: 16,
    paddingBlock: 10,
    fontWeight: 600,
    fontSize: FONT_STYLE.body14L20
  },
  44: {
    paddingInline: 16,
    paddingBlock: 12,
    fontWeight: 700,
    fontSize: FONT_STYLE.body16L20
  },
  50: {
    paddingInline: 16,
    paddingBlock: 15,
    fontWeight: 700,
    fontSize: FONT_STYLE.body16L20
  }
};
/**
 * 버튼의 타입에 따른 style을 반환합니다.
 * @param variant
 * @param shape
 * @param theme
 */
var getBoxButtonVariantStyle = function getBoxButtonVariantStyle(_ref) {
  var variant = _ref.variant,
    shape = _ref.shape,
    theme = _ref.theme;
  var colors = boxButtonColorLookup(theme)[shape][variant];
  return /*#__PURE__*/css("color:", colors.textColor, ";background-color:", colors.backgroundColor, ";border:1px solid ", colors.borderColor, ";&:disabled{background-color:", colors.disabledBackgroundColor, ";color:", colors.disabledTextColor, ";border-color:", colors.disabledBorderColor, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getBoxButtonVariantStyle;"));
};
/**
 * BoxButton의 size에 따른 style을 반환합니다.
 * @param size
 */
var getButtonSizeStyle = function getButtonSizeStyle(size) {
  var _boxButtonSizeLookup$ = boxButtonSizeLookup[size],
    fontSize = _boxButtonSizeLookup$.fontSize,
    fontWeight = _boxButtonSizeLookup$.fontWeight,
    paddingBlock = _boxButtonSizeLookup$.paddingBlock,
    paddingInline = _boxButtonSizeLookup$.paddingInline;
  return /*#__PURE__*/css(fontSize, ";font-weight:", fontWeight, ";padding:", pxToRem(paddingBlock), " ", pxToRem(paddingInline), ";height:", pxToRem(size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:getButtonSizeStyle;"));
};
/**
 * BoxButton내 아이콘의 사이즈를 button size에 알맞은 값으로 반환합니다.
 * @param buttonSize
 */
var getBoxButtonIconSize = function getBoxButtonIconSize(buttonSize) {
  switch (buttonSize) {
    case 28:
    case 32:
    case 40:
      return 16;
    case 44:
    case 50:
      return 18;
    default:
      throw new Error('Invalid button size');
  }
};
/**
 * BoxButton의 variant에 대응하는 loading variant를 반환합니다.
 * @param variant
 * @param shape
 */
var getBoxButtonLoadingVariant = function getBoxButtonLoadingVariant(_ref2) {
  var variant = _ref2.variant,
    shape = _ref2.shape;
  switch (shape) {
    case 'filled':
      switch (variant) {
        case 'primary':
          return 'white';
        case 'neutral-600':
          return 'base1';
      }
      break;
    case 'outlined':
      switch (variant) {
        case 'primary':
          return 'primary1';
        case 'neutral-600':
          return 'base1';
      }
      break;
  }
};

var _excluded$5 = ["children", "leftIcon", "rightIcon", "shape", "variant", "size", "width", "isLoading", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BoxButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = useTheme();
  var children = props.children,
    LeftIcon = props.leftIcon,
    RightIcon = props.rightIcon,
    shape = props.shape,
    variant = props.variant,
    size = props.size,
    width = props.width,
    isLoading = props.isLoading,
    className = props.className,
    restProps = _objectWithoutProperties(props, _excluded$5);
  return jsxs(BoxButtonContainer, _objectSpread2(_objectSpread2({
    ref: ref,
    css: [getBoxButtonVariantStyle({
      variant: variant,
      shape: shape,
      theme: theme
    }), getButtonSizeStyle(size), width && /*#__PURE__*/css({
      width: width
    }, process.env.NODE_ENV === "production" ? "" : ";label:css;")],
    className: classNames(className, {
      loading: isLoading
    })
  }, restProps), {}, {
    children: [LeftIcon && jsx(LeftIcon, {
      "data-testid": "left-icon",
      className: "left-icon",
      size: getBoxButtonIconSize(size)
    }), children, RightIcon && jsx(RightIcon, {
      "data-testid": "right-icon",
      className: "right-icon",
      size: getBoxButtonIconSize(size)
    }), !restProps.disabled && isLoading && jsx(LoadingContainer, {
      children: jsx(Loading, {
        "data-testid": "button-loading",
        variant: getBoxButtonLoadingVariant({
          variant: variant,
          shape: shape
        })
      })
    })]
  }));
});
var BoxButtonContainer = /*#__PURE__*/_styled(BaseButton, process.env.NODE_ENV === "production" ? {
  target: "e5j3oup1"
} : {
  target: "e5j3oup1",
  label: "BoxButtonContainer"
})("border-radius:", pxToRem(4), ";&.loading{pointer-events:none;cursor:default;color:transparent;}.left-icon{margin-right:", pxToRem(4), ";}.right-icon{margin-left:", pxToRem(4), ";}");
var LoadingContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e5j3oup0"
} : {
  target: "e5j3oup0",
  label: "LoadingContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "w382ez",
  styles: "position:absolute;left:0;right:0;top:0;bottom:0;display:flex;align-items:center;justify-content:center;pointer-events:none"
} : {
  name: "w382ez",
  styles: "position:absolute;left:0;right:0;top:0;bottom:0;display:flex;align-items:center;justify-content:center;pointer-events:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var _excluded$4 = ["title", "description", "className", "buttonText", "onButtonClick"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CautionBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
    description = props.description,
    className = props.className,
    buttonText = props.buttonText,
    onButtonClick = props.onButtonClick,
    rest = _objectWithoutProperties(props, _excluded$4);
  return jsxs(Container$2, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    className: className,
    children: [jsxs(Header, {
      children: [jsx(StyledAlertFilledIcon, {
        size: 18,
        fill: function fill(theme) {
          return theme.accent.darken;
        }
      }), jsx(TopText, {
        children: title ? jsx(Title$2, {
          children: title
        }) : jsx(Description$1, {
          as: "span",
          children: description
        })
      })]
    }), title && description && jsx(Description$1, {
      children: description
    }), buttonText && jsx(ButtonWrapper$1, {
      variant: "neutral-600",
      shape: "outlined",
      size: 40,
      onClick: onButtonClick,
      children: buttonText
    })]
  }));
});
var Container$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q6"
} : {
  target: "e1x05w0q6",
  label: "Container"
})("padding:12px 16px;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.base.neutral200;
}, ";border-radius:4px;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.base.neutral100;
}, ";");
var Header = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q5"
} : {
  target: "e1x05w0q5",
  label: "Header"
})();
var StyledAlertFilledIcon = /*#__PURE__*/_styled(AlertFilledIcon, process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q4"
} : {
  target: "e1x05w0q4",
  label: "StyledAlertFilledIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "1qofblv",
  styles: "margin-right:6px;vertical-align:middle"
} : {
  name: "1qofblv",
  styles: "margin-right:6px;vertical-align:middle",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var TopText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q3"
} : {
  target: "e1x05w0q3",
  label: "TopText"
})("color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.base.neutral600;
}, ";");
var Title$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q2"
} : {
  target: "e1x05w0q2",
  label: "Title"
})(FONT_STYLE.body16L24, ";vertical-align:middle;font-weight:700;");
var Description$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q1"
} : {
  target: "e1x05w0q1",
  label: "Description"
})(FONT_STYLE.body15L24, ";font-weight:400;margin-top:4px;");
var ButtonWrapper$1 = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q0"
} : {
  target: "e1x05w0q0",
  label: "ButtonWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "174kkex",
  styles: "width:100%;margin-top:8px"
} : {
  name: "174kkex",
  styles: "width:100%;margin-top:8px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var _excluded$3 = ["size", "width", "title", "placeholder", "icon", "textButton", "hint", "error", "disabled", "count", "value", "onFocus", "onBlur", "className"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var size = props.size,
    width = props.width,
    title = props.title,
    placeholder = props.placeholder,
    icon = props.icon,
    textButton = props.textButton,
    hint = props.hint,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    count = props.count,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded$3);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _ref = icon || {},
    IconComponent = _ref.iconComponent,
    onIconClick = _ref.onClick;
  var _ref2 = textButton || {},
    text = _ref2.text,
    onTextButtonClick = _ref2.onClick;
  var _ref3 = count || {},
    showCount = _ref3.showCount,
    max = _ref3.max;
  var isError = error || showCount && "".concat(value).length > max;
  return jsxs(Container$1, {
    className: className,
    css: [width && /*#__PURE__*/css({
      width: width
    }, process.env.NODE_ENV === "production" ? "" : ";label:css;")],
    "data-testid": "input-container",
    children: [title && jsx(Title$1, {
      children: title
    }), jsxs(InputWrapper, {
      className: classNames('input-wrapper', {
        focused: focused,
        error: isError,
        disabled: disabled
      }),
      "data-testid": "input-wrapper",
      children: [jsx(StyledInput, _objectSpread2(_objectSpread2({
        ref: ref,
        size: size,
        "data-testid": "input"
      }, rest), {}, {
        value: value,
        disabled: disabled,
        placeholder: placeholder,
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
          setFocused(false);
        }
      })), IconComponent && jsx(IconComponent, {
        size: 18,
        className: classNames('input-icon'),
        "data-testid": "input-icon",
        fill: function fill(theme) {
          return theme.base.neutral500;
        },
        onClick: onIconClick,
        style: {
          verticalAlign: 'middle',
          margin: "auto ".concat(text ? '0' : '6px', " auto auto"),
          cursor: 'pointer'
        }
      }), text && jsx(TextButton, {
        size: 14,
        className: classNames('input-text-button'),
        "data-testid": "input-text-button",
        variant: "primary",
        onClick: onTextButtonClick,
        disabled: value === '' || disabled,
        style: {
          verticalAlign: 'middle',
          margin: 'auto 4px auto auto',
          width: 'max-content'
        },
        children: text
      })]
    }), jsxs(StyledHelper, {
      children: [hint && jsx(StyledHint, {
        className: classNames('input-hint', {
          error: isError
        }),
        children: hint
      }), showCount && jsxs(StyledHint, {
        className: classNames('input-count', {
          error: isError
        }),
        style: {
          textAlign: 'right'
        },
        children: ["".concat(value).length, "/", max]
      })]
    })]
  });
});
var Container$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb5"
} : {
  target: "eagkmyb5",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "18un6s6",
  styles: "user-select:none;display:inline-block"
} : {
  name: "18un6s6",
  styles: "user-select:none;display:inline-block",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var Title$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb4"
} : {
  target: "eagkmyb4",
  label: "Title"
})(FONT_STYLE.body14L18, ";margin-bottom:4px;color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.base.neutral500;
}, ";");
var InputWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb3"
} : {
  target: "eagkmyb3",
  label: "InputWrapper"
})("border:1px solid ", function (_ref5) {
  var theme = _ref5.theme;
  return theme.border;
}, ";border-radius:4px;display:flex;width:100%;&.focused{border-color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.primary.basic;
}, ";}&.error{border-color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.accent.basic;
}, ";}&.disabled{border-color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.base.neutral300;
}, ";background-color:", function (_ref9) {
  var theme = _ref9.theme;
  return theme.base.neutral100;
}, ";color:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.base.neutral400;
}, ";}");
var StyledInput = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb2"
} : {
  target: "eagkmyb2",
  label: "StyledInput"
})(RESET_INPUT, ";box-sizing:border-box;color:", function (_ref11) {
  var theme = _ref11.theme;
  return theme.base.neutral700;
}, ";min-width:0;flex:1 1;", function (_ref12) {
  var size = _ref12.size;
  switch (size) {
    case 32:
      return /*#__PURE__*/css(FONT_STYLE.body14L20, ";height:32px;padding:6px 12px;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledInput;"));
    case 40:
      return /*#__PURE__*/css(FONT_STYLE.body16L24, ";height:40px;padding:8px 12px;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledInput;"));
  }
}, " ::placeholder{color:", function (_ref13) {
  var theme = _ref13.theme;
  return theme.base.neutral400;
}, ";}:focus{outline:none;}");
var StyledHelper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb1"
} : {
  target: "eagkmyb1",
  label: "StyledHelper"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var StyledHint = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb0"
} : {
  target: "eagkmyb0",
  label: "StyledHint"
})(FONT_STYLE.detail12L16, ";color:", function (_ref14) {
  var theme = _ref14.theme;
  return theme.base.neutral500;
}, ";margin-top:4px;flex-grow:1;&.error{color:", function (_ref15) {
  var theme = _ref15.theme;
  return theme.accent.basic;
}, ";}");

var _excluded$2 = ["title", "description", "className", "buttonText", "onButtonClick"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Empty = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
    description = props.description,
    className = props.className,
    buttonText = props.buttonText,
    onButtonClick = props.onButtonClick,
    rest = _objectWithoutProperties(props, _excluded$2);
  return jsxs(Container, _objectSpread2(_objectSpread2({
    ref: ref
  }, rest), {}, {
    className: className,
    children: [title && jsx(Title, {
      children: title
    }), description && jsx(Description, {
      children: description
    }), buttonText && jsx(ButtonWrapper, {
      variant: "primary",
      shape: "filled",
      size: 44,
      onClick: onButtonClick,
      children: buttonText
    })]
  }));
});
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt13"
} : {
  target: "e1ijkmt13",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "j1fz9r",
  styles: "padding:12px 16px;text-align:center"
} : {
  name: "j1fz9r",
  styles: "padding:12px 16px;text-align:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Title = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt12"
} : {
  target: "e1ijkmt12",
  label: "Title"
})(FONT_STYLE.heading20, ";font-weight:600;vertical-align:middle;color:", function (_ref) {
  var theme = _ref.theme;
  return theme.base.neutral700;
}, ";");
var Description = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt11"
} : {
  target: "e1ijkmt11",
  label: "Description"
})(FONT_STYLE.body16L24, ";vertical-align:middle;color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.base.neutral500;
}, ";");
var ButtonWrapper = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt10"
} : {
  target: "e1ijkmt10",
  label: "ButtonWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "hkh81z",
  styles: "margin-top:8px"
} : {
  name: "hkh81z",
  styles: "margin-top:8px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

function DesignSystemProvider(_ref) {
  var mode = _ref.mode,
    children = _ref.children;
  var theme = mode === 'dark' ? DARK_THEME : LIGHT_THEME;
  return jsx(ThemeProvider, {
    theme: theme,
    children: jsx(SnackbarProvider, {
      children: jsx(StickyProvider, {
        children: jsx(OverlayProvider, {
          children: children
        })
      })
    })
  });
}
/**
 * @deprecated DesignSystemProvider 컴포넌트를 사용해 주세요.
 */
var BdsProvider = DesignSystemProvider;

var _excluded$1 = ["children", "as", "asProps"],
  _excluded2$1 = ["styles"];
var TEXT_DESCRIPTORS$1 = _objectSpread2({}, TYPOGRAPHY_DESCRIPTOR);
function InnerText(props, ref) {
  var children = props.children,
    _props$as = props.as,
    as = _props$as === void 0 ? 'span' : _props$as,
    asProps = props.asProps,
    restProps = _objectWithoutProperties(props, _excluded$1);
  var theme = useTheme();
  var _extractStyles = extractStyles(restProps, TEXT_DESCRIPTORS$1),
    styles = _extractStyles.styles,
    rest = _objectWithoutProperties(_extractStyles, _excluded2$1);
  var css = createStyles({
    theme: theme,
    props: styles,
    descriptors: TEXT_DESCRIPTORS$1
  });
  return jsx$1(as, _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: css
  }, asProps), children);
}
InnerText.displayName = 'Text';
/**
 * 텍스트 컴포넌트
 * @example
 * <Text
 *   variant="heading24"
 *   color="foreground"
 *   weight={700}
 * >
 *   텍스트
 * </Text>
 */
var Text = /*#__PURE__*/forwardRef(InnerText);

var _excluded = ["children", "level"],
  _excluded2 = ["styles"];
var TEXT_DESCRIPTORS = _objectSpread2({}, TYPOGRAPHY_DESCRIPTOR);
/**
 * 헤딩 컴포넌트
 * @example
 * <Heading
 *   level={1}
 *   variant="heading24"
 *   weight={700}
 * >
 *   텍스트
 * </Heading>
 */
var Heading = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    level = _ref.level,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _extractStyles = extractStyles(props, TEXT_DESCRIPTORS),
    styles = _extractStyles.styles,
    rest = _objectWithoutProperties(_extractStyles, _excluded2);
  var css = createStyles({
    theme: theme,
    props: styles,
    descriptors: TEXT_DESCRIPTORS
  });
  return jsx$1("h".concat(level), _objectSpread2(_objectSpread2({}, rest), {}, {
    ref: ref,
    css: css
  }), children);
});
Heading.displayName = 'Heading';

export { AlertFilledIcon, Avatar, BdsProvider, Box, BoxButton, CautionBox, Chip, CircleBadge, DARK_THEME, DesignSystemProvider, Divider, DotBadge, Empty, FONT_STYLE, Flex, Grid, Heading, HoverInteraction, IconButton, IndicatorDots, InfoIcon, Input, LAYOUT_DESCRIPTOR, LIGHT_THEME, MEDIA_QUERY, OverlayProvider, PillBadge, RESET_BUTTON, RESET_INPUT, ResizeImage, SNACKBAR_PLACEMENT, SnackbarContext, SnackbarProvider, SquareBadge, TYPOGRAPHY_DESCRIPTOR, Text, TextButton, ZINDEX, createStyles, dotSize, extractStyles, pxToRem, safeAreaInset, useSnackbar };
//# sourceMappingURL=index.js.map
